module.exports = __webpack_public_path__ + "static/img/background.a09c3ce1.svg";